// toolkit/api-client/persistHelpers.ts
import type { QueryClient } from '@tanstack/react-query';
import { persistQueryClient } from '@tanstack/react-query-persist-client';
import type { Persister } from '@tanstack/react-query-persist-client';

export const syncDBAfterUpdate = (queryClient: QueryClient, persister: Persister): void => {
  queryClient.getQueryCache().subscribe(() => {
    persistQueryClient({ queryClient, persister });
  });
};
